import styled from 'styled-components';

const ResponsiveImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 5px;
`;

export default ResponsiveImage;
